import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Layout, Menu, Modal } from 'antd';
import './Sider.scss';
import { observer } from 'mobx-react';
import { RouteKey, RouteConfigs, RouteKeys } from 'config/routes';
import { rootContext } from 'stores';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Changepass from '../Changepass/Changepass';
import { getAuth } from 'services/localStorage';
import { Form } from 'antd';
import { IchangePassApiData } from 'types';
import { UserOutlined, CaretDownOutlined } from '@ant-design/icons';
import Changeparameter from 'components/Changepass/Changeparameter';
import { getDefaultReport, updateDefaultReport } from 'services/users';
import logo from "assets/images/logos/lg.png"
import { IsUserAllowed } from 'containers/PrivateContainer';

const Sider: React.FC = observer(() => {
  const {
    AuthStore: {
      onLogOut,
      state: {
        data: { user },
        ui: { changePassLoading, changePassModal }
      },
      setChangePassModal,
      changePass
    }
  } = useContext(rootContext);
  const { SubMenu } = Menu;
  const [changePassForm] = Form.useForm();
  const [changeParameterForm] = Form.useForm();
  const [changeParameterModel, setChangeParameterModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [defaultId, setDefaultId] = useState('');
  const navigate = useNavigate()


  const onFormFinish = async (values: any) => {
    const auth = getAuth();
    if (!auth.user?.id) {
      onLogOut();
      return;
    }
    const apiData = {
      id: auth.user?.id,
      ...values
    } as IchangePassApiData;
    const sucess = await changePass(apiData);
    if (sucess) {
      changePassForm.resetFields();
    }
  };

  const getDefaultParameter = useCallback(async () => {
    setLoading(false);
    const data = await getDefaultReport();
    if (data.data.data) {
      setDefaultId(data.data.data.id);
      changeParameterForm.setFieldsValue({
        days: +data.data.data.default_date_range,
        quantity: +data.data.data.quantity,
        threshold: +data.data.data.threshold
      });
    }
  }, [changeParameterForm]);

  useEffect(() => {
    if (user && ["admin", "super admin"].includes(user.userType)) {
      getDefaultParameter();
    }
  }, [user, getDefaultParameter]);

  const onParamererFormFinish = async (values: any) => {
    setLoading(true);
    const apiData = {
      id: defaultId,
      default_date_range: values.days,
      quantity: values.quantity,
      threshold: values.threshold
    };
    const sucess = await updateDefaultReport(apiData);
    if (sucess) {
      getDefaultParameter();
      setLoading(false);
      setChangeParameterModel(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <Layout.Header className="SiderStyles">
      <div className="Header_logo">
        <Link to="/">
          <img src={logo} alt="logo" />
        </Link>
      </div>
      <Modal
        open={changePassModal}
        onCancel={() => setChangePassModal(false)}
        onOk={() => changePassForm.submit()}
        cancelButtonProps={{ disabled: changePassLoading }}
        okButtonProps={{
          loading: changePassLoading
        }}
        okText="Change Password"
        title="Profile"
        afterClose={() => changePassForm.resetFields()}
      >
        <Changepass form={changePassForm} onFormFinish={onFormFinish} />
      </Modal>
      <Modal
        open={changeParameterModel}
        onCancel={() => setChangeParameterModel(false)}
        onOk={() => changeParameterForm.submit()}
        okButtonProps={{
          loading: loading
        }}
        okText="Update"
        title="Report limits"
        afterClose={() => getDefaultParameter()}
      >
        <Changeparameter
          form={changeParameterForm}
          onFormFinish={onParamererFormFinish}
        />
      </Modal>
      <Menu
        mode="horizontal"
        theme="dark"
        selectedKeys={[`${useLocation().pathname}`]}
      >
        {RouteKeys
          .filter((r: RouteKey) => {
            const value = RouteConfigs[r];
            // Should User see that particular route on navigation or not
            const userAllowedInRoute = value.isStatic || !value.isPrivate ||
              (user?.role_id && IsUserAllowed(value, user));

            return value.topNavigation && userAllowedInRoute;
          })
          .map((r: RouteKey) => {
            const routeData = RouteConfigs[r];
            return (
              <Menu.Item
                key={routeData.path}
                onClick={() => {
                  console.log(routeData.path)
                  navigate(routeData.path)
                }}
              >
                {routeData.name}
              </Menu.Item>
            );
          })}
        <SubMenu
          key="usersubmenu"
          title={
            <>
              {`${user?.username}`}
              <span className="credit">{user?.credit || 0}</span>
            </>
          }
          icon={
            user?.url ? (
              <>
                <img className="userimage" src={user?.url} alt="img" />
                <CaretDownOutlined className="downarrow" />
              </>
            ) : (
              <>
                <UserOutlined />
                <CaretDownOutlined className="downarrow" />
              </>
            )
          }
        >
          <Menu.Item
            onClick={() => {
              setChangePassModal(true);
            }}
          >
            Your Profile
          </Menu.Item>
          <Menu.Item
            onClick={() => {
              setChangeParameterModel(true);
            }}
          >
            Report limits
          </Menu.Item>
          <Menu.Item onClick={onLogOut}>Logout</Menu.Item>
        </SubMenu>
      </Menu>
    </Layout.Header>
  );
});

export default Sider;
